import { makeStyles, Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from "@material-ui/core/Grid";
import { DataStageType, DTPCarousel } from 'meu-inss-ds';
import { convertToItemMenu } from "painel/component/newdashboard/servicos";
import 'pure-react-carousel/dist/react-carousel.es.css';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from "redux";
import { CardsAjuda } from "shared/component/CardsAjuda";
import { getServiceName, launch } from 'shared/helper/serviceLauncher';
import { TK_TIPOS_ACAO_SELECAO_SERVICO, trackServiceSelectORA } from 'shared/helper/tracker';
import { dismissLaunchExternalLink, requestBannerGestaoService, requestSagService, requestServicosSemSenha } from '../painel/actions';
import Footer from "../painel/Footer";
import IconDrawer from '../shared/template/IconDrawer';
import { platform } from 'platformImpl';
import './LoginImpl.css';
import LoadingWrapper from 'shared/component/loading-wrapper';
import { useExternalLinkHandler } from 'painel/component/feedback/useExternalLinkHandler';
import SkipLink from 'shared/component/ds-govbr/Skiplink';

const useStyles = makeStyles(theme => ({
    containerPadding: {
        padding: "0 8px" ,
    },
    paper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'right',
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(3),
            padding: theme.spacing(3, 0),
            marginRight: '0',
            margin: 'auto'
        },
        [theme.breakpoints.up('md')]: {
            paddingTop: theme.spacing(4),
        },
        marginBottom: '8px'
    },
    govbr: {
        fontWeight: 900,
        fontSize: "1.2em",
        fontFamily: 'sans-serif'
    },
    semibold:{
        fontWeight:600,
    },  
    root_login: {
        background: theme.palette.mode === 'dark' ? '' : 'white',
    },
    logoImg: {
        height: '60px'
    },
    appName: {
        fontSize: "2em",
        margin: theme.spacing(0, 0, 1),
        [theme.breakpoints.up('sm')]: {
            margin: '0'
        },
        color: theme.palette.mode === 'dark' ? 'white' : '', 
        top: '5px',
        fontWeight: 'bold'
    },
    descMeuInss: {
        fontSize: "1.1em",
        clear: 'both'
    },
    logoPosition: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row'
        },
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: '34px',
        marginBottom: '34px',
        [theme.breakpoints.up('sm')]: {
            marginTop: '0px',
            marginBottom: '0px',
        }
    },
    submit: {
        display: 'flex',
        marginRight: '0',
        marginBottom: '11px'
    },
    submitLabel: {
        fontWeight: 400,
        fontSize: "1.1em",
    },
    divServicesArea: {
        [theme.breakpoints.down('sm')]: {
            marginBottom: '16px'
        },
        [theme.breakpoints.up('sm')]: {
            background: theme.palette.mode === 'dark' ? "#333" : "#fff",
        },
        paddingBottom: "16px"
    },
    upper: {
        background: theme.web.LoginImpl.upper.background,
        paddingBottom: '0.5px',
        paddingTop: '30px',
        [theme.breakpoints.up('sm')]: {
            paddingTop: '54px',
        }
    },
    carousel: {
        display: 'flex',
        minHeight: '167px !important',
        width: '97vw !important',
        [theme.breakpoints.up('sm')]: {
            minHeight: '190px !important',
            width: '100% !important',
            maxWidth: '960px !important',
        },
    },
    carrousel_content: {
        height: 'auto !important',
        background: '#E1E7F1 !important'
    },
    carrousel_stage: {
        height: '113px !important',
        [theme.breakpoints.up('sm')]: {
            height: '137px !important',
        },
    },
    centraliza: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
    },
    titulo: {
        textAlign: 'center',
        [theme.breakpoints.up('sm')]: {
            textAlign: 'left',
            marginLeft: '10px'
        },
    },
    alinhamento: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',

    },
    opcoes: {
        backgroundColor: theme.overrides.ServicosRecomendados.backgroundColor,
        padding: '16px',
        [theme.breakpoints.down('xs')]: {
            background: theme.palette.mode === 'dark' ? '' : '#f8f8f8',
            marginLeft: '-8px',
            marginRight: '-8px'
        },
    },
    textOpcoes: {
        fontWeight: '600',
        fontSize: '1.2em',
        margin: "0",
        padding: "0",
        color: "#333333",
        marginBottom: "16px",
        [theme.breakpoints.down('xs')]: {
            marginLeft: '8px'
        }
    },
}));

async function getWidth(imageData) {
    return new Promise(function (resolved, rejected) {
        var i = new Image()
        i.onload = function () {
            resolved(i.width)
        };
        i.src = imageData
    })
}

async function filterBanners(bannersSlides, width) {

    const filteredBanners = await Promise.all(
        bannersSlides.map(async (b) => {
            const _width = await getWidth(b.base64);
            return _width === width ? b : null;
        })
    );
    return filteredBanners.filter(b => b !== null);
}

function isMobile() {
    return window.innerWidth <= 600;
}


const Login = (props) => {

    const { banners, loadingBanners, loadingServicosSemSenha, erroBanners, erroServicosSemSenha, feedback, launchExternalLink } = props;
    const [bannersSlides, setBannersSlides] = useState([]);
    const [loadingLogin, setLoadingLogin] = useState(false);
    const [isMobileView, setIsMobileView] = useState(isMobile());
    const classes = useStyles();
    const servicosSemSenha = useSelector(state => state.app.servicosSemSenha?.servicos) || [];    
    const dispatch = useDispatch();

    const getBannerObject = (banner) => {
        let bannerObject = null;
        switch (banner?.tipoUrl) {
            case 1:
                bannerObject = {
                    "externalLink": banner.identificacao,
                    "url": banner?.url
                }
                break;
            case 2:
                if (banner.url.includes("v35/index.html#")) {
                    let path = banner?.url;
                    bannerObject = {
                        "oldVersionService": banner?.identificacao,
                        "rootPath": path?.replace("v35/index.html#", "")
                    }
                } else {
                    bannerObject = {
                        "miService": banner?.identificacao,
                        "path": banner?.url
                    }
                }
                break;
            default:
                break;
        }
        return bannerObject;
    }

    const RenderCarousel = () => {
        return (
            <LoadingWrapper height='170px' isLoading={loadingBanners && bannersSlides.length == 0}>
                { bannersSlides.length > 0 &&
                    <DTPCarousel
                        key={isMobileView ? 'listMobile' : 'listWeb'}
                        items={bannersSlides}
                        className={classes.carousel}
                        classNameStage={classes.carrousel_stage}
                        classNameContent={`${classes.carrousel_content}`}
                        dataStage={DataStageType.HIBW}
                        dataMobileNav={isMobileView}
                        dataCircular={true}
                    /> 
                }
                {
                    erroBanners && bannersSlides.length === 0 &&
                    <RenderMensagemErro />
                }
            </LoadingWrapper>
        )

    };

    const RenderMensagemErro = () => {
        return  <div>
                    Serviço não disponível no momento.
                </div>
    }

    useEffect(() => {

        props.requestSagService();
        
        dispatch({
            type: "APP_ITENS_SERVICOS_RECOMENDADOS_RECEBICOS",
            payload: null
        });

        props.requestServicosSemSenha();

        // Atualiza a visualização móvel ao redimensionar a janela
        const handleResize = () => {
            setIsMobileView(isMobile());
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        props.requestBannerGestaoService();
        sessionStorage.removeItem('sagTkn');
        dispatch(dismissLaunchExternalLink());
    }, []);

    useEffect(() => {
        async function loadBanners() {
            if (banners) {
                const width = isMobileView ? 248 : 760;
                const filteredBanners = await filterBanners(banners, width);

                const bannerComponents = filteredBanners.map((b, index) => (
                    <button
                        key={index}
                        style={{
                            cursor: 'pointer',
                            border: 'none',
                            padding: 0,
                            width: 'calc(100% - 80px)',
                            maxWidth: isMobileView ? '248px' : '760px',
                            maxHeight: isMobileView ? '113px' : '137px',
                            backgroundColor: 'transparent',
                        }}
                        role="button"
                        onClick={() => {
                            trackServiceSelectORA(TK_TIPOS_ACAO_SELECAO_SERVICO.LOGOUT, getServiceName(getBannerObject(b)));
                            launch(getBannerObject(b));
                        }}
                    >
                        <img src={b.base64} alt={b.textoAcessibilidade} />
                    </button>
                ));
                setBannersSlides(bannerComponents);
            }
        }
        loadBanners();
    }, [banners, isMobileView]);

    useEffect(() => {
        const handleSkipLinkClick = (event) => {
            const id = (event.currentTarget.hash || '').replace(/^#\/?/, '');
            if (id === "main-content") {
                event.preventDefault();
                const mainContent = document.getElementById("main-content");

                if (mainContent) {
                    mainContent.focus();
                }
            }
            else if (id === "footer") {
                event.preventDefault();
                const footerContent = document.getElementById("footer");

                if (footerContent) {
                    footerContent.focus();
                }
            }
            else if (id === "menu") {
                event.preventDefault();
                const menuContent = document.getElementById("menu");

                if (menuContent) {
                    menuContent.focus();
                }
            }
        };

        const skipLinks = document.querySelectorAll(".br-skiplink a");
        skipLinks.forEach((link) => link.addEventListener("click", handleSkipLinkClick));

        return () => {
            skipLinks.forEach((link) => link.removeEventListener("click", handleSkipLinkClick));
        };
    }, []);

    const addOrigemClickAsRotasDosServicos = () => {
        if(servicosSemSenha){
            //TODO REMOVER QUANDO O NOVO BREADCRUMB FOR INTEGRADO, passar apenas o servicoSemSenha sem o map.
            return servicosSemSenha.map(
                servico => {
                    let item = convertToItemMenu(servico) || {};
                    let field = item.hasOwnProperty("pagePath") ? "pagePath" : ( item.hasOwnProperty("path") ? "path" : null);
                    if(field && !item[field].includes("origem-click=MENU")){
                        let queryParamChar = item[field].includes("?") ? '&' : "?";
                        let novoPath = `${item[field]}${queryParamChar}origem-click=MENU`;
                        return { ...item, [field]: novoPath }
                    }
                    return item;
                }
            );
        }else{
            return servicosSemSenha;
        }
    }

    const RenderServicosSemSenha = () => {
        return(
            <>
                <h2 className={classes.textOpcoes} >Serviços sem senha</h2>
                <LoadingWrapper height='170px' isLoading={loadingServicosSemSenha && servicosSemSenha.length == 0}>
                    { servicosSemSenha.length > 0 && 
                        <nav className={classes.opcoes} id="menu" aria-label="Menu de serviços sem senha." tabIndex={-1}>
                            <IconDrawer
                                clickActionName={TK_TIPOS_ACAO_SELECAO_SERVICO.LOGOUT}
                                items={addOrigemClickAsRotasDosServicos()}
                                responsive
                            />    
                        </nav>
                    }
                    {
                        erroServicosSemSenha && servicosSemSenha.length === 0 &&
                        <RenderMensagemErro />
                    }
                </LoadingWrapper>
            </>
        )
    }
    
    useExternalLinkHandler(
        {feedback, launchExternalLink}
    );

    return (
        <React.Fragment>
            <CssBaseline />
            <div className={classes.root_login}>
                <SkipLink />
                <header className={classes.upper} role='banner' aria-labelledby="header-main-title">
                    <Container className={classes.containerPadding} maxWidth="md">
                        <div className={classes.logoPosition}>
                            <div className={classes.meu_inss_logo_and_name}>
                                <Box className={classes.logo}>
                                    <img id="logo_white_background" src={require('../assets/img/inss-logo.webp')}
                                        className={classes.logoImg} alt="Meu INSS" />
                                </Box>
                            </div>
                            <div className={classes.titulo}>
                                <Typography id="header-main-title" variant={"h1"} className={classes.appName}>
                                    Meu INSS
                                </Typography>
                                <Typography variant={"h2"} className={classes.descMeuInss}>
                                    Conheça e acesse os serviços do INSS
                                </Typography>
                            </div>
                        </div>
                    </Container>
                </header>
                <main>
                    <Container component="section" className={classes.containerPadding} maxWidth="md">
                        <Grid style={{ alignContent: 'right', alignItems: 'right' }}>
                            <Grid item xs={12} md={12} className={classes.alinhamento}>
                                <div className={`${classes.paper}`}>
                                    <form className={classes.form}>
                                        <button
                                            className={`br-button primary large ${loadingLogin ? 'loading' : ''}`}
                                            id='main-content'
                                            style={{fontWeight: 'normal', width: '100%', marginBottom: '8px'}}
                                            onClick={(e) => {
                                            e.preventDefault();
                                            if (!platform.isCordova) setLoadingLogin(true);
                                            props.abrirGovbr();
                                            }}
                                        >
                                            <span>Entrar com <span className={classes.semibold}>gov.br</span></span>
                                        </button>
                                        <p style={{ fontSize: '0.8em', textAlign: 'right' }}>
                                            Entre com a senha gov.br ou faça o cadastro.
                                        </p>
                                    </form>
                                </div>
                            </Grid>
                            <Grid item xs={12} md={12} className={`${classes.alinhamento} govbr`}>
                                <RenderCarousel />
                            </Grid>
                        </Grid>
                    </Container>
                <section className={classes.divServicesArea} >
                    <Container className={classes.containerPadding} maxWidth="md">
                        <RenderServicosSemSenha />
                    </Container>
                </section>
                <Container component="section" className={classes.containerPadding} maxWidth="md">
                    <CardsAjuda rotaCanaisAjuda="/aberto/ajuda" />
                </Container>
            </main>
            </div>
            <Footer />
        </React.Fragment>
    );
}

const mapDispatchToProps = dispatch => bindActionCreators({
    requestBannerGestaoService,
    requestServicosSemSenha,
    requestSagService
}, dispatch);

const mapStateToProps = state => ({
    banners: state.app.banners,
    loadingBanners: state.app.loadingBanners,
    loadingServicosSemSenha: state.app.loadingServicosSemSenha,
    erroBanners: state.app.erroBanners,
    erroServicosSemSenha: state.app.erroServicosSemSenha,
    feedback: state.feedback,
    launchExternalLink: state.app.launchExternalLink,
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);